import './assets/css/site.css';
import './polyfills/find-polyfill';
import './polyfills/findIndex-polyfill';
import './polyfills/includes-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { createBrowserHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import { I18nMessages, i18nMessages } from './modules/i18n/configureI18n';
import { I18nProvider } from './modules/i18n/components/I18nProvider';
import * as RoutesModule from './routes';
import { ApplicationState } from './state/ducks';
import configureStore from './state/store';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

let routes = RoutesModule.routes;

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
// tslint:disable-next-line:no-any
const initialState = (window as any).initialReduxState as ApplicationState;
const store = configureStore(history, initialState);

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: 'b8acb33b-23dd-43b5-9979-231f4a55387d',
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history }
        }
    }
});

appInsights.loadAppInsights();

function renderApp(messages: I18nMessages) {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.render(
        React.createElement(
            withAITracking(
                reactPlugin,
                () => (
                    <Provider store={store}>
                        <I18nProvider messages={messages}>
                            <ConnectedRouter history={history} children={routes} />
                        </I18nProvider>
                    </Provider>
                ),
                undefined,
                'app'
            )
        ),
        document.getElementById('root'),
    );
}

renderApp(i18nMessages);